<template>
  <div id="preview">
    <overlay-loading-progress :LoadingFlag="OverlayLoadingFlag" />
    <v-card>
      <v-app-bar
        color="primary"
        dense
        dark
        elevate-on-scroll
        scroll-target="#scrolling-techniques-7"
      >
        <v-toolbar-title> {{ pageDescription }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="closePrompt">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <v-card-text>
        <v-container class="py-0" v-if="StartupLoadingFlag">
          <v-skeleton-loader v-bind="attrs" type="table-tbody" />
        </v-container>

        <v-container class="py-0" v-if="ResultFlag">
          <v-row wrap>
            <!-- Profile Section -->
            <v-col cols="12" class="text-center mb-6">
              <v-avatar size="110" class="elevation-4">
                <img :src="recordData.MemberImagePath" />
              </v-avatar>
              <h3 class="mt-3 font-weight-bold">
                {{ recordData.MemberFullname }}
              </h3>
              <h5 class="text--secondary">
                {{ recordData.MembershipId }}
              </h5>
            </v-col>

            <!-- Info Section -->
            <v-col cols="12">
              <v-card outlined class="pa-4 mb-4 rounded-lg elevation-1">
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <label class="font-weight-bold text-h6 mb-1"
                      >Designation</label
                    >
                    <br />
                    <p class="text-subtitle-1">
                      {{ recordData.NominationDesignationName }}
                    </p>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label class="font-weight-bold text-h6 mb-1"
                      >Application Status</label
                    >
                    <br />
                    <v-chip :color="recordData.NominationStatusColor" dark>
                      {{ recordData.NominationStatusTxt }}
                    </v-chip>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label class="font-weight-bold text-h6 mb-1"
                      >NHQ Status</label
                    >
                    <br />
                    <v-chip :color="recordData.VerifyStatusColor" dark>
                      {{ recordData.VerifyStatusTxt }}
                    </v-chip>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label class="font-weight-bold text-h6 mb-1"
                      >LO Certification</label
                    >
                    <br />
                    <v-chip :color="recordData.PresidentStatusColor" dark>
                      {{ recordData.PresidentStatusTxt }}
                    </v-chip>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label class="font-weight-bold text-h6 mb-1">Zone</label>
                    <br />
                    <p class="text-subtitle-1">
                      {{ recordData.ZoneName || "NA" }}
                    </p>
                  </v-col>

                  <v-col cols="12" sm="6" md="3">
                    <label class="font-weight-bold text-h6 mb-1">LO</label>
                    <br />
                    <p class="text-subtitle-1">{{ recordData.LomName }}</p>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <!-- Nomination Application -->
            <v-col cols="12" class="mt-4">
              <v-card outlined class="pa-4 rounded-lg elevation-1">
                <h4 class="blue--text mb-2">Nomination Application</h4>
                <template v-if="recordData.NominationApplicationPath">
                  <a
                    :href="recordData.NominationApplicationPath"
                    target="_blank"
                    class="text-primary text-subtitle-1 font-weight-medium"
                    style="text-decoration: underline"
                  >
                    View Nomination Form
                  </a>
                </template>
                <template v-else>
                  <p class="text-danger">No document uploaded</p>
                </template>
              </v-card>
            </v-col>

            <!-- Documents -->
            <v-col cols="12" class="mt-4">
              <v-card outlined class="pa-4 rounded-lg elevation-1">
                <h4 class="blue--text mb-3">Nomination Documents</h4>
                <br />
                <v-row>
                  <v-col
                    v-for="document in recordData.NominationDocuments"
                    :key="document.DocumentId"
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                  >
                    <v-card
                      outlined
                      class="pa-4 rounded-lg elevation-1 hover:elevation-4"
                    >
                      <h5 class="text-primary mb-2">
                        {{ document.DocumentTypeName }}
                      </h5>
                      <a
                        :href="document.PdfUrl"
                        target="_blank"
                        class="text-decoration-underline text-primary text-subtitle-1"
                      >
                        View Document
                      </a>
                      <p class="text-subtitle-2 mt-2 grey--text">
                        {{ document.DocumentDescription }}
                      </p>
                    </v-card>
                  </v-col>
                </v-row>
                <template v-if="recordData.NominationDocuments.length === 0">
                  <p class="text-danger">No nomination documents found</p>
                </template>
              </v-card>
            </v-col>
          </v-row>
          <v-row wrap>
            <v-form
              ref="form2"
              v-model="valid1"
              lazy-validation
              v-on:submit.prevent="submitForm"
              style="width: 100%"
            >
              <v-col cols="12">
                <label>
                  <h3 class="mt-3 font-weight-bold">Description History</h3>
                </label>
              </v-col>
              <v-col cols="12">
                <v-card outlined class="pa-3 mb-4 rounded-lg elevation-1">
                  <div
                    v-if="recordData.DescriptionHistory"
                    v-html="recordData.DescriptionHistory"
                  ></div>
                  <div v-else>
                    <p class="text-danger">No previous description found</p>
                  </div>
                </v-card>
              </v-col>

              <!-- Existing textarea for new description -->
              <v-col cols="12">
                <label>
                  <h3 class="mt-3 font-weight-bold">New Description</h3>
                </label>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  outlined
                  v-model="Description"
                  :rules="DescriptionRules"
                  name="input-7-4"
                  label="Enter new description"
                  class="text-h6"
                ></v-textarea>
              </v-col>

              <v-row justify="center" class="mt-4">
                <v-col cols="12" md="auto" class="d-flex justify-center">
                  <v-btn
                    :disabled="!valid1"
                    @click.prevent="submitForm(1)"
                    :loading="ApproveLoadingFlag"
                    color="success"
                    elevation="6"
                    shaped
                    large
                    class="px-8 py-3 mx-2 white--text"
                  >
                    Approve
                  </v-btn>

                  <v-btn
                    :disabled="!valid1"
                    @click.prevent="submitForm(2)"
                    :loading="RejectLoadingFlag"
                    color="warning"
                    elevation="6"
                    shaped
                    large
                    class="px-8 py-3 mx-2 white--text"
                  >
                    Reject
                  </v-btn>

                  <v-btn
                    @click="closePrompt"
                    color="primary"
                    elevation="6"
                    shaped
                    large
                    class="px-8 py-3 mx-2 white--text"
                  >
                    Cancel
                  </v-btn>
                </v-col>
              </v-row>
              <br />
            </v-form>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>


<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [common],
  components: {},
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    row: {
      required: true,
    },
    category: {
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      recordData: [],
      TrainingDocuments: [],
      ResultFlag: false,
      StartupLoadingFlag: false,

      OverlayLoadingFlag: false,
      ReportType: "",
      valid1: true,
      Description: "",
      DescriptionRules: [(v) => !!v || "Description is required"],
    };
  },
  computed: {},
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    recordData: function () {
      console.log("watch recordData");
      this.StartupLoadingFlag = false;
      var tr = this.recordData;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      this.ResultFlag = n1 > 0 ? true : false;
      this.ReportType = n1 > 0 ? tr.CategoryName : "";
      this.TrainingDocuments = n1 > 0 ? tr.TrainingDocuments : [];
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideDialog", true);
    },
    validate() {
      console.log("validate is called");
      var result = this.$refs.form.validate();
      console.log("result=" + result);
      if (result) {
        this.addRecordDetails();
      } else {
        console.log("some errors occured");
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.getRecordDetails();
    },
    getRecordDetails() {
      console.log("getRecordDetails called");
      this.ResultFlag = false;
      this.StartupLoadingFlag = true;
      this.TrainingDocuments = [];
      var tr = this.row;
      console.log({ tr });
      var id = tr.NominationId;
      var list_url = "api/nomination/show";
      var where = {
        Nomination: id,
      };
      console.log("list_url=" + list_url + ", where=" + JSON.stringify(where));
      this.getTableData("recordData", list_url, where);
    },
    submitForm(Status) {
      console.log("submitForm is called");

      console.log({ Status });

      var message = "";

      var validate1 = this.$refs.form2.validate();
      console.log({ validate1 });

      var tr = this.row;
      console.log({ tr });

      var id = tr.NominationId;
      console.log(id);

      // var validate1 = false;

      if (validate1 && Status > 0 && id > 0) {
        this.OverlayLoadingFlag = true;

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/nomination/admin-approval-update";
        var upload = {
          UserInterface: Status,
          Nomination: id,
          Description: this.Description,
          Lom: tr.LomId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.StatusFlag = false;

        const thisIns = this;
        var output = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));
            thisIns.OverlayLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            if (flag == 1) {
              thisIns.StatusFlag = true;
              thisIns.sweetAlert("success", output, true);
              thisIns.closePrompt();
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
          });
      } else {
        if (!validate1) {
          message = "Kindly fill the required fields. ";
        }
        if (Status == null || Status == "") {
          message = "Status is invalid. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
